import Lottie from 'react-lottie'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { AppRoutes } from '@constants/app-routes'
import { useLottieLoopHandler } from '@hooks/use-lottie-loop-handler'
import { useMediaQuery } from '@hooks/use-media-query'
import Icon from '@public/images/hexagon-no-fill.svg'
import { NormalizedWrapper } from '@theme'
import { ArrowLink } from '@ui/links/ArrowLink'
import { Column } from '@ui/sections/Column'
import { Description } from '@ui/sections/Description'

import {
  StyledPolygon,
  ImageWrapper,
  ContentBox,
  Container,
  TableTitle,
  TableSubtitle,
  LottieWrapper,
} from './styles'

const defaultStyle = {
  position: 'absolute',
  margin: '0 auto',
}

export function AchievementSection({ title, subtitle, config, type }) {
  const isMobile = useMediaQuery('(max-width: 620px')

  const {
    handleOnMouseOver,
    handleOnMouseLeave,
    handleLoopComplete,
    handleIsStopped,
  } = useLottieLoopHandler(config.length, isMobile)

  const handlerOnMouseOver = id => () => handleOnMouseOver(id)

  return (
    <NormalizedWrapper className="wrapper">
      <StyledPolygon className="hexagon" />
      <Column>
        <Description padding="9%" title={title} subtitle={subtitle} />
        <ContentBox className="card-container">
          {config.map(
            ({
              id,
              title: contentTitle,
              subtitle: contentSubtitle,
              imagePath,
              alt,
              imageHeight,
              imageWidth,
              imageTitle,
              lottie,
              lottieWidth,
              lottieHeight,
              lottieImage,
              style,
            }) => (
              <Container key={id} type={type} className="container">
                {imagePath &&
                  (imagePath === '/' || (
                    <ImageWrapper width={imageWidth} height={imageHeight}>
                      <ImageWithPlaceholder
                        src={imagePath}
                        alt={alt}
                        width={imageWidth}
                        height={imageHeight}
                        title={imageTitle}
                      />
                    </ImageWrapper>
                  ))}
                {lottie && (
                  <LottieWrapper
                    onMouseOver={handlerOnMouseOver(id)}
                    onMouseLeave={handleOnMouseLeave}
                  >
                    {lottieImage || <Icon />}
                    <Lottie
                      isStopped={handleIsStopped(id)}
                      options={{
                        loop: true,
                        animationData: lottie,
                        autoplay: false,
                        rendererSettings: {
                          preserveAspectRatio: 'xMidYMid slice',
                        },
                      }}
                      eventListeners={[
                        {
                          eventName: 'loopComplete',
                          callback: handleLoopComplete,
                        },
                      ]}
                      speed={1.7}
                      width={lottieWidth}
                      height={lottieHeight}
                      style={{ ...style, ...defaultStyle }}
                    />
                  </LottieWrapper>
                )}
                {contentTitle && (
                  <TableTitle as="h3">{contentTitle}</TableTitle>
                )}
                <TableSubtitle>{contentSubtitle}</TableSubtitle>
              </Container>
            )
          )}
        </ContentBox>
        <ArrowLink
          href={AppRoutes.aboutUs}
          className="link-arrow"
          if="Achievement Section Arrow Link"
          alt="about us"
        >
          Learn more
        </ArrowLink>
      </Column>
    </NormalizedWrapper>
  )
}
